<template>
  <v-card class="elevation-1 pa-3 login-card">
    <v-card-text>
      <div class="layout column align-center">
        <img
          alt="Transit Web"
          height="120"
          src="/static/Transit-logo-animacion.gif"
          width="120"
        />
        <h1 class="flex my-4 primary--text">¡Bienvenidos!</h1>
      </div>
      <v-form>
        <v-text-field
          data-vv-name="email"
          label="Email"
          prepend-icon="alternate_email"
          required
          type="email"
          v-model="form.email"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
        ></v-text-field>
        <v-text-field
          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          data-vv-name="password"
          label="Contraseña"
          prepend-icon="lock"
          v-validate="'required'"
          :error-messages="errors.collect('password')"
          v-model="form.password"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <div class="login-btn">
      <v-spacer></v-spacer>
      <v-btn :loading="loading" @click="login" block color="primary"
        >Login</v-btn
      >
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    showPassword: false,
    form: {
      email: '',
      password: '',
    },
  }),

  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true
          this.$store
            .dispatch('session/login', {
              email: this.form.email,
              upass: this.form.password,
            })
            .then(response => {
              const { role } = response.data
              this.loading = false
              if (response.status === 200) {
                if (this.$acl.isAdmin(role)) {
                  this.$router.push('/dashboard')
                } else if (this.$acl.isAccounting(role)) {
                  this.$router.push('/transit/pago-de-impuestos')
                } else if (this.$acl.isDelivery(role)) {
                  this.$router.push('/transit/entregas')
                } else if (
                  this.$acl.isLaboratory(role) ||
                  this.$acl.isDistributor(role) ||
                  this.$acl.isClient(role)
                ) {
                  this.$router.push('/dashboard')
                } else {
                  this.$router.push('/transit/facturas')
                }
              } else {
                alert(response.data.error)
              }
            })
        }
      })
    },
  },
}
</script>
